import { db, familyDb, type AegaeDb } from "./db";

/** A store and its wire owner; family profile ids and row userIds use family_id. */
export interface LedgerRef {
  kind: "personal" | "family";
  db: AegaeDb;
  ownerId: string;
}
export function personalLedger(userId: string): LedgerRef { return { kind: "personal", db, ownerId: userId }; }
export function familyLedger(familyId: string): LedgerRef { return { kind: "family", db: familyDb, ownerId: familyId }; }
